import { StoreBadge } from '@/components/common/StoreBadge';

import { getAppStoreConfig } from '@/config/appStore';

interface StoreButtonsProps {
  /** Extra classes for the wrapping flex container (spacing/alignment). */
  className?: string;
}

/**
 * Official App Store / Google Play download badges in the active UI language.
 * Renders only the platforms whose availability flag is on, and nothing when
 * none are available (pre-launch).
 */
export function StoreButtons({ className = '' }: StoreButtonsProps) {
  const { ios, android, anyAvailable } = getAppStoreConfig();

  if (!anyAvailable) return null;

  return (
    <div
      className={`flex flex-wrap items-center gap-3 ${className}`}
      data-testid="store-buttons"
    >
      {ios.available && <StoreBadge store="ios" />}
      {android.available && <StoreBadge store="android" />}
    </div>
  );
}
